import {Product} from '../../@types/wishlist.js';
import {FilterOption} from './filter-option.js';
import {FilterAction} from './filter-action.js';

export class FilterCountCache {
  private readonly cache = new Map<string, Map<string, number>>();

  public getCounts(
    products: Product[],
    filterId: string,
    options: FilterOption[],
    activeOptions: string[] = [],
  ): Map<string, number> {
    const cacheKey = this.createCacheKey(products, filterId, activeOptions);

    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    const counts = this.calculateCounts(products, options);

    this.cache.set(cacheKey, counts);

    return counts;
  }

  private calculateCounts(
    products: Product[],
    options: FilterOption[],
  ): Map<string, number> {
    const counts = new Map<string, number>();

    options.forEach((option) => {
      counts.set(option.id, 0);
    });

    products.forEach((product) => {
      options.forEach((option) => {
        let shouldCount = true;

        if (option.action instanceof FilterAction) {
          shouldCount = option.action.filterStrategy(product);
        }

        if (shouldCount) {
          const currentCount = counts.get(option.id) ?? 0;
          counts.set(option.id, currentCount + 1);
        }
      });
    });

    return counts;
  }

  private createCacheKey(
    products: Product[],
    filterId: string,
    activeOptions: string[]
  ): string {
    const productHash = products.length > 100
      ? `${products.length}-${products[0]?.syan}-${products[products.length - 1]?.syan}`
      : products.map(p => p.syan).join(',');
    return `${productHash}-${filterId}-${activeOptions.join(',')}`;
  }

  public invalidate(): void {
    this.cache.clear();
  }
}
